const isBrowser = typeof window !== 'undefined';

const isMobile = {
    Android() {
        return isBrowser && /Android/i.test(navigator.userAgent);
    },
    BlackBerry() {
        return isBrowser && /BlackBerry/i.test(navigator.userAgent);
    },
    iOS() {
        return isBrowser && /iPhone|iPad|iPod/i.test(navigator.userAgent);
    },
    Opera() {
        return isBrowser && /Opera Mini/i.test(navigator.userAgent);
    },
    Windows() {
        return isBrowser && /IEMobile/i.test(navigator.userAgent);
    },
    any() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

export { isBrowser, isMobile };
export default { isBrowser, isMobile };
